module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '1jy3zxjl',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
